import React from "react";

interface Practitioner {
  name: string;
}

interface Summary {
  practitioner: Practitioner;
  specialty: string;
  teleconsult_date: string;
  subject: string;
  object: string;
  icd_code: string;
  icd_name: string;
  plan: string;
  file_url: string;
}

interface SummaryProps {
  summary: Summary;
  doctorName: string;
  doctorSpecialty: string;
}

const Summary: React.FC<SummaryProps> = ({ summary, doctorName, doctorSpecialty }) => {
  console.log("Summary component rendered with:", summary, doctorName, doctorSpecialty);
  return (
    <div
      style={{
        padding: "10px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#eaf4ff",
        fontSize: "12px",
        boxSizing: "border-box",
      }}
    >
      <p style={{ margin: "0 0 10px", color: "#00bfa5", textAlign: "center" }}>
        <b>Consultation Summary</b>
      </p>
      <hr style={{ border: "none", borderTop: "1px solid #ddd" }} />
      <table>
        <tbody>
          <tr>
            <td>Doctor</td>
            <td>:</td>
            <td>{doctorName || "N/A"}</td>
          </tr>
          <tr>
            <td>Speciality</td>
            <td>:</td>
            <td>{doctorSpecialty || "N/A"}</td>
          </tr>
          <tr>
            <td>Date</td>
            <td>:</td>
            <td>{summary.teleconsult_date || "N/A"}</td>
          </tr>
        </tbody>
      </table>

      <hr style={{ border: "none", borderTop: "1px solid #ddd" }} />
      <table>
        <tbody>
          <tr>
            <td>Subjek</td>
            <td>:</td>
            <td>{summary.subject || "N/A"}</td>
          </tr>
          <tr>
            <td>Objek</td>
            <td>:</td>
            <td>{summary.object || "N/A"}</td>
          </tr>
          <tr>
            <td>Assessment</td>
            <td>:</td>
            <td>
              {(summary.icd_code || summary.icd_name)
                ? `${summary.icd_code} ${summary.icd_name}`.trim()
                : "N/A"}
            </td>
          </tr>
          <tr>
            <td>Plan</td>
            <td>:</td>
            <td>{summary.plan || "N/A"}</td>
          </tr>
          <tr>
            <td>Download File</td>
            <td>:</td>
            <td>
              {summary.file_url ? (
                <a
                  style={{ textDecoration: "none", color: "#007bff" }}
                  href={summary.file_url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Download Summary
                </a>
              ) : (
                "N/A"
              )}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default Summary;
